<template>
    <div style="padding: 10px 20px; height: 5%;">
        <el-table :data="tableData" border style="width: 100%" :header-cell-style="headerCellStyle">
            <el-table-column prop="name" label="名称" width="200">
            </el-table-column>
            <el-table-column prop="description" label="描述">
            </el-table-column>
            <el-table-column prop="actived" label="状态" width="180">
            </el-table-column>
        </el-table>
    </div>
</template>
<style></style>
<script>
import axios from "axios";
export default {
    data() {
        return {
            headerCellStyle: {
                backgroundColor: '#F8F8F9'
            },
            tableData: []
        }
    },
    mounted() { },
    methods: {
        async getAtuoNumberWhereUsed() {
            axios.get('/pmdm/admin/autonumber/queryWhereUsedById?id=' + this.$store.state.objectId.id).then(res => {
                if (res.data.code == 200) {
                    let data = res.data.object.subClsList;
                    this.tableData = data.map((item) => {
                        return {
                            name: item.name,
                            description: item.description,
                            actived: item.actived === 1 ? "启用" : "禁用"
                        };
                    });
                }
            }).catch(function (error) { });
        }
    },
    created() {
        this.getAtuoNumberWhereUsed();
    },
};
</script>
<style scoped></style>